module.exports = __webpack_public_path__ + "img/search-property.28217d79.svg";